import { generateTestId } from "@client-shared";

export const setFinanceDashboardViewTestId = (identifier: string): string => generateTestId("FinanceDashboardView", identifier);

// Container
export const setFinanceDashboardViewContainerTestId = (): string => setFinanceDashboardViewTestId("container");

// Header
export const setFinanceDashboardViewTitleTestId = (): string => setFinanceDashboardViewTestId("title");
export const setFinanceDashboardViewDescriptionTestId = (): string => setFinanceDashboardViewTestId("description");
export const setFinanceDashboardViewDateRangeSelectorTestId = (): string => setFinanceDashboardViewTestId("date-range-selector");
export const setFinanceDashboardViewCountrySelectorTestId = (): string => setFinanceDashboardViewTestId("country-selector");

// Metric Cards
export const setFinanceDashboardViewTotalInvoicesCardTestId = (): string => setFinanceDashboardViewTestId("total-invoices-card");
export const setFinanceDashboardViewPaidCardTestId = (): string => setFinanceDashboardViewTestId("paid-card");
export const setFinanceDashboardViewUnpaidOverdueCardTestId = (): string => setFinanceDashboardViewTestId("unpaid-overdue-card");
export const setFinanceDashboardViewCrossBorderCardTestId = (): string => setFinanceDashboardViewTestId("cross-border-card");
export const setFinanceDashboardViewExceptionsCardTestId = (): string => setFinanceDashboardViewTestId("exceptions-card");

// Charts
export const setFinanceDashboardViewStatusDistributionChartTestId = (): string =>
  setFinanceDashboardViewTestId("status-distribution-chart");
export const setFinanceDashboardViewPaymentTrendChartTestId = (): string => setFinanceDashboardViewTestId("payment-trend-chart");

// Cross-Border and Tax Compliance sections
export const setFinanceDashboardViewCrossBorderSummaryTestId = (): string => setFinanceDashboardViewTestId("cross-border-summary");
export const setFinanceDashboardViewTaxComplianceTestId = (): string => setFinanceDashboardViewTestId("tax-compliance");

// Worklist section
export const setFinanceDashboardViewWorklistTestId = (): string => setFinanceDashboardViewTestId("worklist");
export const setFinanceDashboardViewViewAllButtonTestId = (): string => setFinanceDashboardViewTestId("view-all-button");
